// Read More / Show Less toggle for the product description block
// (main-product.liquid renders .product-description-short / .product-description-full
// with .read-more anchors when the description exceeds 200 characters).
// Vanilla JS replacement for the legacy jQuery handler; event-delegated so it
// also works if the section is re-rendered.
(function () {
  function toggle(link) {
    var shortEl = document.querySelector('.product-description-short');
    var fullEl = document.querySelector('.product-description-full');
    if (!shortEl || !fullEl) return;
    var showFull = fullEl.style.display === 'none';
    fullEl.style.display = showFull ? 'block' : 'none';
    shortEl.style.display = showFull ? 'none' : 'block';
    var focusTarget = showFull ? fullEl : shortEl;
    var anchor = focusTarget.querySelector('.read-more');
    if (anchor) anchor.focus();
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.read-more');
    if (!link) return;
    event.preventDefault();
    toggle(link);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var link = event.target.closest && event.target.closest('.read-more');
    if (!link) return;
    event.preventDefault();
    toggle(link);
  });
})();
